<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <RentsReport />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import RentsReport from '@/components/Reports/Rents/RentsReport'

export default {
  name: 'ReportsRentsView',
  components: {
    Layout,
    RentsReport
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Início',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatórios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Aluguéis',
        to: { name: 'ReportRents' },
        active: true
      }
    ]
  }
}
</script>
